﻿import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { makeStyles } from '@mui/styles';
import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import background from '../../assets/images/teal-stethoscope-on-wooden-table.png';
import IconLoader from '../../components/IconLoader';
import { useClientTheme } from '../../helpers/hooks/useClientTheme';

const useStyles = makeStyles((theme: any) => ({
  container: {
    backgroundImage: `url(${background})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    height: '100%',
  },
}));

interface HomePageProps {}

const HomePage: React.FC<HomePageProps> = (): ReactElement => {
  const classes = useStyles();
  const { t } = useTranslation('common');
  const { isDefaultTheme, theme } = useClientTheme();
  const LogoComponent = theme.images.mainLogo;

  return (
    <Grid container sx={{ height: '100vh', overflow: 'hidden' }}>
      <Grid size={{ xs: 12, sm: 8, md: 5 }}
        style={{ maxHeight: '100vh', overflow: 'auto' }}




        component={Paper}
        elevation={6}
        square
      >
        <Box
          sx={{
            my: 4,
            mx: 10,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {isDefaultTheme ? null : (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100px',
              }}
            >
              <img
                src={LogoComponent}
                alt="Client Logo"
                style={{
                  height: '100%',
                  maxWidth: '100%',
                  objectFit: 'contain',
                }}
              />
            </Box>
          )}

          <Box sx={isDefaultTheme ? { mt: 8 } : { mt: 0 }}>
            <Outlet />
          </Box>

          <Box
            sx={{
              mt: 3,
            }}
          >
            {isDefaultTheme ? null : (
              <Typography
                sx={{
                  mb: 1,
                }}
              >
                {t('poweredBy')}
              </Typography>
            )}

            <IconLoader name="WalkWithPathLogo" />
          </Box>
        </Box>
      </Grid>
      <Grid size={{ xs: false, sm: 4, md: 7 }} className={classes.container} />
    </Grid>
  );
};

export default HomePage;
